<div class="content contentHeight">
    <div class="contentHome">
        <div class="container">
            <h1 class="text-center" [translate]="'home.titleIntro'"></h1>
            <!--<button class="btn btn-secondary" (click)="enableGoogleAnalytics()">test GA</button>-->
            <!--<button class="btn btn-secondary" (click)="testClickGA()">test click GA</button>
            <button class="btn btn-secondary" (click)="testClickGA2()">test click GA 2</button>-->

            <p class="text-center font-italic" [translate]="'home.intro'"></p>
            <!--<span id="device-detector">{{Math.max(documentElement.clientWidth || 0, window.innerWidth || 0)}}*{{Math.max(documentElement.clientHeight || 0, window.innerHeight || 0)}}: </span>-->
        <div class="home">
            <div *ngIf="!Utils.isAttum(role) && !Utils.isAxalta(role) && !Utils.isAkzo(role)" class="tuile">
                <div class="colorBook cardHome backgroundWhiteRound" routerLink="/colorbook" (click)="launchColorbook()">
                    <h3 [translate]="'home.colorbookTitle'" class="mb-0"></h3>
                    <div class="blueRect"></div>
                    <img class="iconGeneriqueHome" src="assets/colorbook-online-round.png" alt="" />
                    <label class="name mt-2">ColorBook online</label>
                </div>
            </div>
            <div *ngIf="!Utils.isAttum(role) && !Utils.isAxalta(role) && !Utils.isAkzo(role)" class="tuile">
                <div class="colorwebTech cardHome backgroundWhiteRound" routerLink="/colorwebtech" (click)="launchColorwebtech()">
                    <h3 [translate]="'home.colorwebtechTitle'" class="mb-0"></h3>
                    <div class="purpleRect"></div>
                    <img class="iconGeneriqueHome" src="assets/colorwebtech-round.png" alt="" />
                    <label class="name mt-2">ColorWebTech</label>
                </div>
            </div>

            <div *ngIf="!Utils.isAttum(role) && Utils.isAkzo(role)" class="tuile">
                <div class="colorwebTech cardHome backgroundWhiteRound" routerLink="/equinox" (click)="launchColorwebtechEquinox()">
                    <h3 [translate]="'home.colorwebtechTitle'" class="mb-0"></h3>
                    <div class="purpleRect"></div>
                    <img class="iconGeneriqueHome" src="assets/colorwebtech-round.png" alt="" />
                    <label class="name mt-2">ColorWebTech</label>
                </div>
            </div>

            <div *ngIf="!Utils.isAttum(role) && Utils.isAxalta(role)" class="tuile">
                <div class="colorwebTech cardHome backgroundWhiteRound" routerLink="/colorwebtech" (click)="launchColorwebtech()">
                    <h3 [translate]="'home.colorwebtechTitle'" class="mb-0"></h3>
                    <div class="purpleRect"></div>
                    <img class="iconGeneriqueHome" src="assets/colorwebtech-round.png" alt="" />
                    <label class="name mt-2">ColorWebTech</label>
                </div>
            </div>

            <div *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role) || Utils.isCTC(role) || Utils.isUserIxell(role) || Utils.isAttum(role)" class="tuile">
                <div class="assistance cardHome backgroundWhiteRound" routerLink="/support" (click)="launchSupport()">
                    <h3 [translate]="'home.assistanceTitle'" class="mb-0"></h3>
                    <div class="yellowRect"></div>
                    <img class="iconGeneriqueHome" src="assets/assistance-round.png" alt="" />
                    <label [translate]="'home.assistance'" class="name mt-2"></label>
                </div>
            </div>
            <div *ngIf="Utils.isAdminLacour(role)" class="tuile">
                <div class="assistance cardHome backgroundWhiteRound" routerLink="/adminhome">
                    <h3 class="mb-0"> Gestion des licences, commandes, locations </h3>
                    <div class="greenRect"></div>
                    <img class="iconGeneriqueHome" src="assets/gestion-round.png" alt="" />
                    <label class="name mt-2"> Administration</label>
                </div>
            </div>
            <div *ngIf="Utils.isAttum(role)" class="mx-auto">
                <a href="{{urlPortailTuto}}" target="_blank" class="tuto" rel="noopener noreferrer">
                    <div class="cardHome backgroundWhiteRound">
                        <h3 class="mb-0" [translate]="'actionmateriel.faq'"></h3>
                        <div class="greyRect"></div>
                        <div class="text-dark text-center textAction">
                            <i aria-hidden="true" class="fal fa-question fa-6x textIcon"></i>
                        </div>
                    </div>
                </a>
            </div>



            <div *ngIf="Utils.isAdminLacour(role) || Utils.haveGPI()" class="tuile">
                <a href="{{urlColorCloud}}" target="_blank" class="linkColorCloud" rel="noopener noreferrer">
                    <div class="ColorWebOnline cardHome backgroundWhiteRound">
                        <h3 [translate]="'home.ixellVisionConnect'" class="mb-0"></h3>
                        <div class="greenRect"></div>
                        <img class="iconIVCBlackP" src="assets/IconeIVCBlackP.png" alt="" />
                        <label class="name mt-2">IxellVision Connect</label>
                    </div>
                </a>
            </div>

            <!--<div *ngIf="Utils.isAdminLacour(role) || Utils.haveCWI()" class="tuile tuileHide">-->
            <div *ngIf="Utils.isAdminLacour(role) || isSitePilote" class="tuile">
                <a href="{{urlColorWebOnline}}" target="_blank" class="linkColorWebOnline" rel="noopener noreferrer">
                    <div class="ColorClouod cardHome backgroundWhiteRound">
                        <h3 [translate]="'home.ixellVisionLight'" class="mb-0"></h3>
                        <div class="greyRect"></div>
                        <img class="iconGeneriqueHome" src="assets/IxellVisionLight.png" alt="" />
                        <label class="name mt-2">IxellVision Light</label>
                    </div>
                </a>
            </div>

        <div *ngIf="(Utils.isUserIxell(role) || Utils.isCTC(role) || Utils.isAxalta(role)) && !Utils.isAdminLacour(role)" class="tuile" >
          <div class="assistance cardHome backgroundWhiteRound" [routerLink]="path" (click)="launchContretypage()">
            <h3 class="mt-2 mb-0"> Pour contretyper vos éléments à peindre</h3>
            <div class="orangeRect"></div>
            <img class="iconGeneriqueHome" src="assets/contretypage.png" alt=""/>
            <label class="name mt-2"> Contretypage </label>
          </div>
        </div>

        <!--<div class="tuile ">
          <div class="assistance cardHome backgroundWhiteRound" (click)="launchImportantInformation()">
            <h3 [translate]="'home.infoImportante'" class="mt-2 mb-0"></h3>
            <div class="redRect"></div>
            <img src="assets/info-important-round.png" alt="" />
            <label [translate]="'home.infoImportante'" class="name mt-2"></label>
          </div>
        </div>

    <div id="ModalImportantInformation" class="modal">
      <div class="modal-content importantInformationContent">

        <div class="pdf">
          <iframe *ngIf="language == 'fr'" id="importantInformationIFrame" width="100%" height="775" src="../../assets/InformationImportante/reformulationNoteClients_fr.pdf" type="application/pdf" title=""></iframe>
          <iframe *ngIf="language != 'fr'" id="importantInformationIFrame" width="100%" height="775" src="../../assets/InformationImportante/reformulationNoteClients_en.pdf" type="application/pdf" title=""></iframe>
        </div>

        <div class="importantInformationValidation-container">
          <button id="importantInformationValidation" class="btn btn-success btn-lg" (click)="closeImportantInformation()">{ 'shoppingcart.validate' | translate }}</button>
        </div>

      </div>


    </div>-->

        </div>
        </div>
    </div>

